(function(app) {

    app.constant("accountTypes",
    [
        { Label: "Qualified", Value: "Qualified" },
        { Label: "Non-Qualified", Value: "NonQualified" },
        { Label: "Other (Explain)", Value: "Other" }
    ]);
})(window.app);